import styled from 'styled-components';

export const NoResultsImage = styled.svg`
  margin: 0 auto;
  display: block;
`;
